import React from 'react'
import styled from 'styled-components'
import breakpoints from '../config/Breakpoints'
import NoContent from './NoContent'

interface Props {
	message: string
	adjustForSmallScreen?: boolean
	size?: '1em' | '2em' | '3em' | '4em' | '5em' | '6em'
}

const NoContentForFullScreen: React.FC<Props> = ({ message = '찾으시는 내용이 없어요', adjustForSmallScreen, size }) => {
	return (
		<Container adjustForSmallScreen={adjustForSmallScreen ?? false}>
			<NoContent message={message} size={size} />
		</Container>
	)
}

const Container = styled.div<{ adjustForSmallScreen: boolean }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	@media (max-width: ${breakpoints.md}) {
		top: ${props => (props.adjustForSmallScreen ? '70%' : '50%')};
	}
`

export default NoContentForFullScreen
